import { Article } from "src/components/Article/Article";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

function ArticleContainer() {
	return (
		<LayoutWithSearch className="h-100">
			<Article />
		</LayoutWithSearch>
	);
}

export default ArticleContainer;
